(function () {
  "use strict";

  ManageGroupsCtrl.$inject = ['$scope', '$rootScope', '$location', 'resolveData', '$window', 'groupsResource', 'compositeSearchData', 'sortHelper', '$timeout', 'authView', 'manageGroupsSearch', 'mtypes', 'usersResource', 'trainerPrivilege'];
  angular
    .module('trainerWebApp.controllers')
    .controller('ManageGroupsCtrl', ManageGroupsCtrl);

  function ManageGroupsCtrl($scope, $rootScope, $location, resolveData, $window, groupsResource, compositeSearchData,
                            sortHelper, $timeout, authView, manageGroupsSearch, mtypes, usersResource, trainerPrivilege) {

    $window.document.title = "Manage Groups | Mindflash Training Management System";

    $rootScope.page = {name: 'manageGroups', title: "Manage Groups"};
    var groups = resolveData.groups;
    var users = resolveData.users;
    var restrictedTrainers = {};
    var currentSortColumn;

    $scope.canEditGroups = trainerPrivilege.roles().canEditGroups;

    $scope.viewModel = {
      showTrainerPermissions: authView.showUserPermissionsManagement() ? true : false,
      showCreateGroupButton: !mfConfig.useGroupRestrictions && $scope.canEditGroups
    };

    $scope.groups = groups.sort(sortHelper.getStringPropertySorter({field: 'name', asc: true}));

    if ($scope.viewModel.showTrainerPermissions) {
      groupsResource.getGroupTrainers(function (result) {
        restrictedTrainers = _.groupBy(result.allRestrictedTrainers, 'id');
      });
    }

    var searchText = $scope.openSidebarPlaceholder = $scope.viewModel.showTrainerPermissions ? "Search by group, trainer, manager, or user" : "Search by group or user";
    $scope.overridePlaceholder = searchText;
    $scope.openSidebarPlaceholder = searchText;

    setData();

    function setData() {
      $scope.gridData = $scope.groups;
      $scope.numberOfGroupsLabel = $scope.groups.length;
    }

    var searchData = compositeSearchData.getSearchData();

    compositeSearchData.clearSearchData();

    var gridCommands = $scope.gridCommands = {};

    $scope.manageGroupsEditors = {
      editGroupUsersSidebarDirty: false,
      editGroupTrainersSidebarDirty: false,
      editGroupNameSidebarDirty: false
    };

    $scope.selectedGroup = null;
    $scope.collapsedSidebarSrc = null;

    setupSearch();

    $scope.gridInfo = {
      options: {
        editable: false,
        enableCellNavigation: false,
        asyncEditorLoading: false,
        enableColumnReorder: false,
        forceFitColumns: true,
        forceSyncScrolling: $scope.gridData.length < 500,
        multiColumnSort: true
      },
      highlightRowsEnabled: true,
      columns: [
        {
          id: "name",
          name: "Group Name",
          field: "name", width: 300,
          cssClass: "cell-title",
          headerCssClass: "bold",
          sortable: true
        },
        {
          id: "num-of-users",
          name: "Users",
          field: "userCount", width: 300,
          cssClass: "cell-title",
          headerCssClass: "bold",
          sortable: true
        }
      ],
      onClick: function (item, targetClasses, target, args) {
        $scope.onRowClick(item, targetClasses);
      },
      onRowCountChanged: onRowCountChanged,
      data: [],
      filterFn: filterer
    };

    $scope.onRowClick = function (item, targetClasses) {
      if (!groups || groups.length == 0) return;

      selectGroup(item);
    };

    function onRowCountChanged(args, items) {
      $scope.numberOfGroupsLabel = items.length;

      validateSelectedItem(items);
    }

    function validateSelectedItem(items) {
      if (!$scope.selectedGroup) {
        return;
      }

      var found = _.find(items, function (i) {
        return i.id == $scope.selectedGroup.id;
      });
      if (!found) {
        $scope.selectedGroup = null;
        $scope.sidebarContentSrc = null;
      }
    }

    function highlightRow(group) {
      if (gridCommands.highlightGridRow)
        gridCommands.highlightGridRow(group && group.id);
    }

    function selectGroup(group) {
      if (($scope.selectedGroup && $scope.selectedGroup == group)) {
        return;
      }

      $scope.viewModel.showTrainerPermissions = authView.showUserPermissionsManagement() ? true : false;

      if (editorsAreDirty()) {
        interruptSelectionChange([group]);
        return;
      }

      $scope.selectedGroup = group;

      $scope.openSingleUserDetailsSidebar();

      highlightRow(group);
    }


    $scope.showSpinner = function () {
      $rootScope.$broadcast('$showLoadingSpinner', true);
    };

    $scope.hideSpinner = function () {
      $rootScope.$broadcast('$showLoadingSpinner', false);
    };

    $scope.openSingleUserDetailsSidebar = function () {
      $scope.changeSidebar('pages/group/groupDetailSidebar.html');
    };

    $scope.changeSidebar = function (sidebarSrc) {
      $scope.sidebarContentSrc = sidebarSrc;
    };

    $scope.$watch('sidebarContentSrc', function (newSrc, oldSrc) {
      if (newSrc == oldSrc) {
        return;
      }
      $(window).trigger('resize');
      $timeout(function () {
        $scope.forceGridResize();
      });
    });

    $scope.searchClick = function (groupId) {
      compositeSearchData.setSearchData('group', groupId);
      $location.path('/TMS/ManageUsers/');
    };

    var groupToSelect = null;

    function interruptSelectionChange(group) {
      groupToSelect = group;
      $scope.$broadcast('showUnsavedChanges', {
        cancelEventName: 'cancelSelection',
        leaveEventName: 'proceedWithSelection',
        text: 'You have made changes in this view - changing views now will cause your changes to be lost. \r\n Do you wish to continue?',
        title: 'Discard changes?',
        leaveButtonTitle: 'Discard',
        cancelButtonTitle: 'Save'
      });
    }

    $scope.$on('proceedWithSelection', function () {
      clearEditorsDirtyFlags();
      selectGroup(groupToSelect[0]);
      groupToSelect = null;
    });

    $scope.$on('cancelSelection', angular.noop);

    function clearEditorsDirtyFlags() {
      _.each(_.keys($scope.manageGroupsEditors), function (k) {
        $scope.manageGroupsEditors[k] = false;
      });
    }

    $scope.refreshData = function () {
      var selectedGroupId = $scope.selectedGroup ? $scope.selectedGroup.id : -1;
      groupsResource.getGroups(function (result) {
        $scope.groups = result.sort(sortHelper.getStringPropertySorter({field: 'name', asc: true}));
        $scope.gridData = restoreSortIn($scope.groups);
        setData();
        if (selectedGroupId > 0) {
          var groupToSelect = _.find($scope.groups, function (g) {
            return g.id == selectedGroupId;
          });
          if (groupToSelect) {
            selectGroup(null);
            selectGroup(groupToSelect);
          }
        }

        if ($scope.viewModel.showTrainerPermissions) {
          groupsResource.getGroupTrainers(function (result) {
            restrictedTrainers = _.groupBy(result.allRestrictedTrainers, 'id');
            $scope.$broadcast("refreshSearch");
          });
        } else {
          $scope.$broadcast("refreshSearch");
        }
      });
    };


    var sortByName = sortHelper.getStringPropertySorter({field: 'name', asc: true});


    function sort(a, b) {
      if (!(typeof gridCommands.sort === 'function'))
        return sortByName(a, b);

      currentSortColumn = gridCommands.sort();
      if (!currentSortColumn)
        return sortByName(a, b);

      var column = currentSortColumn.columnId.toString();
      if (column == 'name') {
        var value1 = a["name"].toLowerCase();
        var value2 = b["name"].toLowerCase();
        return sortBy(value1, value2);
      } else {
        var value1 = a["userCount"];
        var value2 = b["userCount"];
        return sortBy(value1, value2);
      }
    }

    function sortBy(a, b) {
      var sign = currentSortColumn ? currentSortColumn.sortAsc ? 1 : -1 : 1;
      return ((a < b) ? -1 : ((a > b) ? 1 : 0)) * sign;
    }

    function restoreSortIn(data) {
      return data.sort(sort);
    }

    $scope.createGroup = function () {
      $location.path('/TMS/ManageGroups/CreateGroup');
    };

    $scope.closeSidebar = function () {
      if (editorsAreDirty()) {
        $scope.$broadcast('showUnsavedChanges', {
          cancelEventName: 'cancelSelection',
          leaveEventName: 'proceedWithCloseSidebar',
          text: 'By changing the selected users, your changes will be lost. Are you sure you want to continue?'
        });
        return;
      }
      $scope.proceedWithSidebarCollapse();
    };

    function editorsAreDirty() {
      return _.some(_.values($scope.manageGroupsEditors), function (v) {
        return v;
      })
    }

    $scope.proceedWithSidebarCollapse = function () {
      $scope.sidebarContentSrc = null;
    };

    $scope.openSidebar = function () {
      $scope.sidebarContentSrc = $scope.collapsedSidebarSrc;
    };

    $scope.$watch('sidebarContentSrc', function (newValue, oldValue) {
      if (oldValue && !newValue && $scope.selectedGroup && $scope.selectedGroup.deleted != true)
        $scope.collapsedSidebarSrc = oldValue;
      else
        $scope.collapsedSidebarSrc = null;
    });

    var searchFilter = null;

    function setupSearch() {

      var trainers = [];
      var managers = [];

      if ($scope.viewModel.showTrainerPermissions) {
        trainers = _.filter(users, function (u) {
          return u.permissions == mtypes.userRole.trainer;
        });
        managers = _.filter(users, function (u) {
          return u.permissions == mtypes.userRole.manager;
        });
      }

      $scope.searchSettings = manageGroupsSearch.createSearchSettings({
        groups: $scope.groups,
        users: _.filter(users, function (u) {
          return u.isInGroup == 1;
        }),
        trainers: trainers,
        managers: managers,
        setFilter: setSearchFilter,
        filterHasResults: filterHasResults,
        gaPageName: "",
        notifySearchChanged: notifySearchChanged,
        showTrainerPermissions: $scope.viewModel.showTrainerPermissions,
        isUsernameEnabled: $scope.isUsernameEnabled,
        getUserGroups: function (id, cb) {
          usersResource.getUserInfo(id, function (res) {
            cb(res.groupMemberships)
          });
        },
        getTrainerGroups: function (id, cb) {
          if (restrictedTrainers[id]) {
            cb(_.pluck(restrictedTrainers[id], 'groupId'));
          } else {
            cb();
          }
        }
      });
    }

    function setSearchFilter(filter) {
      searchFilter = filter;
      $scope.applyGridFilter();
    }

    $scope.applyGridFilter = function () {
      $scope.gridFilterData = {
        searchFilter: searchFilter
      };
    };

    $scope.applyGridFilter();

    function filterer(itemToFilter, args) {
      if (!args) return true;
      var group = sortHelper.getDataFromGridItem(itemToFilter);

      return !args.searchFilter || args.searchFilter(group);
    }

    function filterHasResults(searchFilter) {
      if (!searchFilter) {
        return false;
      }

      var group = _.find($scope.getVisibleGridItems(), function (g) {
        return filterer(g, $scope.gridFilterData) && searchFilter(g);
      });

      return !!group;
    }

    function notifySearchChanged(items) {
    }

    if (searchData && searchData.name == 'group') {
      var group = _.find($scope.groups, function (g) {
        return g.id == searchData.id;
      });
      if (group) {
        $timeout(function () {
          selectGroup(group);
          gridCommands.scrollHighlightRowTop(group.id);
        });
      }
    }
  }

})();
